import * as Yup from "yup";

const CouponValidationSchema = Yup.object().shape({
  couponCount: Yup.number()
    .required("Coupon count is required")
    .min(1, "At least one coupon must be generated"),
  precode: Yup.string().required("Code is required").trim(),

  description: Yup.string().required("Description is required").trim(),

  discountType: Yup.string()
    .oneOf(["percentage", "cash"])
    .required("Discount Type is required"),

  discountValue: Yup.number()
    .typeError("Must be a number")
    .required("Discount Value is required")
    .min(0, "Discount must be at least 0"),

  usageLimit: Yup.number()
    .typeError("Must be a number")
    .required("Usage Limit is required")
    .min(0, "Usage limit must be at least 0"),

  usageCount: Yup.number()
    .typeError("Must be a number")
    .required("Usage Count is required")
    .min(0, "Usage count must be at least 0"),

  perUserUsageLimit: Yup.number()
    .typeError("Must be a number")
    .required("Per User Usage Limit is required")
    .min(0, "Per-user limit must be at least 0"),

  active: Yup.string()
    .oneOf(["true", "false"])
    .required("Please select active status"),

  maxLimitDiscount: Yup.number()
    .typeError("Must be a number")
    .required("Max Limit Discount is required")
    .min(0, "Maximum discount must be at least 0"),

  minSpend: Yup.number()
    .typeError("Must be a number")
    .required("Min Spend is required")
    .min(0, "Minimum spend must be at least 0"),

  isUserSpecific: Yup.string()
    .oneOf(["true", "false"])
    .required("Please specify if user-specific"),

  targetUserId: Yup.string().nullable().notRequired(),
  couponReference: Yup.string().required("Coupon reference is required"),
  viewable: Yup.boolean().optional().required(),
  sharable: Yup.boolean().optional().required(),
  categoryId: Yup.number().required("Category Id is Required"),
  isCollegeSpecific: Yup.boolean().required(),
  targetCollegeId: Yup.number().nullable().notRequired(),
  targetCollegeName: Yup.string().nullable().notRequired(),
  isUniversitySpecific: Yup.boolean().required(),
  targetUniversityId: Yup.number().nullable().notRequired(),
  targetUniversityName: Yup.string().nullable().notRequired(),
  isCourseSpecific: Yup.boolean().required(),
  targetCourseId: Yup.number().nullable().notRequired(),
  targetCourseName: Yup.string().nullable().notRequired(),
  remainingBalance: Yup.number()
    .min(0, "Remaining balance cannot be negative")
    .required("Remaining balance is required"),
  supportsPartialUsage: Yup.boolean().required(),
});
export default CouponValidationSchema;
